module.exports = __webpack_public_path__ + "img/icon-close-f0c6f360.svg";